/**
 * URL の正規表現
 * 空白を含まずに日本語が書かれた場合に match しないようにしている
 */
const urlRegex =
  /(https?:\/\/[\w.~:/?#[\]@!$&'()*+,;=-]*\.[\w.~:/?#[\]@!$&'()*+,;=-]+)/g;

export function renderLinkifiedText(text: string) {
  const elements = getElements(text);

  return (
    <>
      {elements.map((element, index) => (
        // eslint-disable-next-line react/no-array-index-key, @typescript-eslint/no-base-to-string
        <span key={`${String(element)}-${index}`}>{element}</span>
      ))}
    </>
  );
}

function getElements(text: string) {
  const chunks = text.split(urlRegex);

  return chunks.map((item, index) => {
    if (item.match(urlRegex) === null) return item;

    return (
      // eslint-disable-next-line react/no-array-index-key
      <a key={index} href={item} target='_blank' rel='noopener noreferrer'>
        {item}
      </a>
    );
  });
}
